var map = {
	"./es/CookieConsent": [
		4821,
		821
	],
	"./es/CookieConsent.json": [
		4821,
		821
	],
	"./es/QuizModule": [
		9228,
		983
	],
	"./es/QuizModule.json": [
		9228,
		983
	],
	"./es/common": [
		10357,
		357
	],
	"./es/common.json": [
		10357,
		357
	],
	"./es/landing-page": [
		81465,
		465
	],
	"./es/landing-page.json": [
		81465,
		465
	],
	"./pt/CookieConsent": [
		94968,
		968
	],
	"./pt/CookieConsent.json": [
		94968,
		968
	],
	"./pt/common": [
		41400,
		400
	],
	"./pt/common.json": [
		41400,
		400
	],
	"./pt/landing-page": [
		2565,
		565
	],
	"./pt/landing-page.json": [
		2565,
		565
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 30242;
module.exports = webpackAsyncContext;